// extracted by mini-css-extract-plugin
module.exports = {"root":"banner-photo_root__dgWqd","iconsContainer":"banner-photo_iconsContainer__hFbVT","photoContainer":"banner-photo_photoContainer__sCLBD","photo":"banner-photo_photo__9Eocm"};